/**
 * 청구 extraFields.accidentType → 라우팅 키 (백엔드 InsurerClaimFaxSettingService 와 동일 규칙)
 * - 질병 → DISEASE
 * - 그 외(재해·상해·교통사고·자살·기타·기타:…) → INJURY
 */
export function accidentCategoryKeyFromAccidentType(accidentTypeRaw) {
  const t = String(accidentTypeRaw || '').trim()
  if (!t) return null
  const base = t.includes(':') ? t.slice(0, t.indexOf(':')).trim() : t
  return base === '질병' ? 'DISEASE' : 'INJURY'
}

/** API에서 내려온 insurer fax 설정 + 사고유형 → 가상팩스 비교·안내용으로 쓸 번호 */
export function resolveListedClaimFaxNumber(cfg, accidentTypeRaw) {
  if (!cfg) return ''
  const cat = accidentCategoryKeyFromAccidentType(accidentTypeRaw)
  let routing = cfg.claimFaxRoutingJson
  if (typeof routing === 'string' && routing.trim()) {
    try {
      routing = JSON.parse(routing)
    } catch {
      routing = null
    }
  }
  if (cat && routing && typeof routing === 'object' && routing.byAccidentCategory) {
    const br = routing.byAccidentCategory[cat]
    if (br != null && String(br).trim() !== '') return String(br).trim()
  }
  return String(cfg.claimFaxNumber || '').trim()
}

export function accidentTypeFromApplication(application) {
  if (!application) return ''
  try {
    if (application.extraFields && typeof application.extraFields === 'object') {
      return String(application.extraFields.accidentType || '').trim()
    }
    const raw = application.extraFieldsJson
    if (raw && typeof raw === 'string') {
      const j = JSON.parse(raw)
      return String(j?.accidentType || '').trim()
    }
  } catch {
    /* ignore */
  }
  return ''
}

export function buildClaimFaxRoutingPayload(diseaseFax, injuryFax) {
  const d = String(diseaseFax || '').trim()
  const i = String(injuryFax || '').trim()
  if (!d && !i) return null
  return JSON.stringify({
    byAccidentCategory: {
      ...(d ? { DISEASE: d } : {}),
      ...(i ? { INJURY: i } : {}),
    },
  })
}

export function parseClaimFaxRoutingFields(claimFaxRoutingJson) {
  let routing = claimFaxRoutingJson
  if (typeof routing === 'string' && routing.trim()) {
    try {
      routing = JSON.parse(routing)
    } catch {
      routing = null
    }
  }
  const by = routing && typeof routing === 'object' ? routing.byAccidentCategory : null
  return {
    faxRoutingDisease: by && by.DISEASE != null ? String(by.DISEASE) : '',
    faxRoutingInjury: by && by.INJURY != null ? String(by.INJURY) : '',
  }
}
